import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { accountSelectors } from '../redux/modules/account';
import { AccountProduct } from '../common/types/Accounts';

type HasAccountProductsFunc = (...products: AccountProduct[]) => boolean;

export const useAccountProducts = (): HasAccountProductsFunc => {
  const activeAccount = useSelector(accountSelectors.selectActiveAccount);

  return useCallback(
    (...products) =>
      products.every(product =>
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        (activeAccount.products || []).includes(product),
      ),
    [activeAccount],
  );
};

export default useAccountProducts;
